import { render, staticRenderFns } from "./zj-roll.vue?vue&type=template&id=71ee3108&scoped=true"
import script from "./zj-roll.vue?vue&type=script&lang=js"
export * from "./zj-roll.vue?vue&type=script&lang=js"
import style0 from "./zj-roll.vue?vue&type=style&index=0&id=71ee3108&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ee3108",
  null
  
)

export default component.exports